import './Spinner.scss';
import { defineComponent, PropType} from 'vue';

export default defineComponent({
    props: {
        text: {
            required: true,
            type: null as any as PropType<string | undefined>,
        },
    },

    data() {
        return {
            elem: document.querySelector('#loader')!,
            textElem: document.querySelector('#loader span:last-of-type')!,
        };
    },

    watch: {
        text(value: typeof this.text) {
            if (!value)
                this.elem.classList.add('hidden');
            else {
                this.elem.classList.remove('hidden');
                this.textElem.innerHTML = value;
            }
        },
    },

    mounted() {
        if (!this.text)
            this.elem.classList.add('hidden');
        else {
            this.elem.classList.remove('hidden');
            this.textElem.innerHTML = this.text;
        }
    },

    render() { return ''; },
});
